module.exports = __webpack_public_path__ + "static/media/avatar-placeholder-male.65fdd5c9.png";